export const BASE_PATH = "/auth";

export const STATE_SEARCH_PARAM = "state";
export const ERROR_CODE_SEARCH_PARAM = "errorCode";
export const ACCESS_CODE_SEARCH_PARAM = "accesscode";
export const REDIRECT_SEARCH_PARAM = "redirect";
export const LOGIN_TAB_SEARCH_PARAM = "sec";
export const USETPA_SEARCH_PARAM = "usetpa";
export const SIGNUP_SEARCH_PARAM = "signup";
export const AUTHLEVEL_SEARCH_PARAM = "authlevel";
export const AUTHLEVEL_SEARCH_PARAM_CAMEL_CASE = "authLevel";

export const LOGIN_TAB = "login";
export const ONE_TIME_LOGIN_TAB = "pcbang";
export const QR_LOGIN_TAB = "qr";

export const MAX_NEST_INIT_TRY_COUNT = 3;

export const GETO_PC_ACCESS_CODE = 2000088041;
export const GETO_MOBILE_ACCESS_CODE = 2000088043;
export const MSW_ACCESS_CODE = 2000088068; // 메이플스토리월드 소프트런칭 전용
export const STELLA_ACCESS_CODE = 2000088066; // 스텔라 인앱 웹뷰
export const DEFAULT_MOBILE_JOIN_ACCESS_CODE = 2000076001; // 모바일 기본 가입 accesscode
export const DEFAULT_PC_JOIN_ACCESS_CODE = 1; // PC 기본 가입 accesscode
